"use client";
import { j as o } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as u from "react";
import Y, { useMemo as $, useCallback as Q } from "react";
import { t as X } from "./tv.config-BuYIgndg.mjs";
import { l as Z } from "./Field.style-CQ8CRW6E.mjs";
import { RadioGroupProvider as ee } from "./RadioGroupContext.js";
import { RadioIndexProvider as oe } from "./RadioIndexContext.js";
import { u as te } from "./useControlled-B2rPEZCb.mjs";
import { c as re, m as ae } from "./useRenderElement-B8V3_e8R.mjs";
import { u as I } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as h } from "./useEventCallback-CjuAhyNz.mjs";
import { v as se } from "./visuallyHidden-DPuANzJJ.mjs";
import { u as ie } from "./useBaseUiId-a-UPSsPQ.mjs";
import { S as ne } from "./composite-D7hKyvC5.mjs";
import { C as le } from "./CompositeRoot-DqjHHBWD.mjs";
import { u as ue } from "./FormContext-CYX6HnEQ.mjs";
import { u as de, a as ce } from "./useFieldControlValidation-B3M7EPH2.mjs";
import { u as me, f as pe } from "./FieldRootContext-Cj7-dNhd.mjs";
import { R as fe } from "./RadioGroupContext-CJkO5W0s.mjs";
import { c as Re } from "./element-DE7VsBMX.mjs";
import { F as ge, b as xe, a as he } from "./FieldDescription-LT07Zs4i.mjs";
import { F as ve } from "./FieldLabel-C2NVcnds.mjs";
const Ve = [ne], M = /* @__PURE__ */ u.forwardRef(function(d, s) {
  const {
    render: i,
    className: c,
    disabled: l,
    readOnly: t,
    required: r,
    onValueChange: R,
    value: k,
    defaultValue: S,
    name: w,
    inputRef: O,
    id: T,
    ..._
  } = d, {
    labelId: D,
    setTouched: C,
    setFocused: v,
    validationMode: V,
    name: z,
    disabled: H,
    state: g
  } = me(), n = de(), {
    clearErrors: y
  } = ue(), m = H || l, p = z ?? w, P = ie(T), [e, F] = te({
    controlled: k,
    default: S,
    name: "RadioGroup",
    state: "value"
  }), x = u.useRef(null), j = h((a) => {
    x.current == null && a != null && (x.current = a);
  });
  ce({
    id: P,
    commitValidation: n.commitValidation,
    value: e,
    controlRef: x,
    name: p,
    getValue: () => e ?? null
  });
  const E = u.useRef(e);
  I(() => {
    E.current !== e && (y(p), V === "onChange" ? n.commitValidation(e) : n.commitValidation(e, !0));
  }, [p, y, V, e, n]), I(() => {
    E.current = e;
  }, [e]);
  const [N, b] = u.useState(!1), K = h((a) => {
    Re(a.currentTarget, a.relatedTarget) || (C(!0), v(!1), V === "onBlur" && n.commitValidation(e));
  }), q = h((a) => {
    a.key.startsWith("Arrow") && (C(!0), b(!0), v(!0));
  }), G = h(R), B = u.useMemo(() => e == null ? "" : typeof e == "string" ? e : JSON.stringify(e), [e]), L = re(n.inputRef, O), A = ae({
    value: B,
    ref: L,
    id: P,
    name: p,
    disabled: m,
    readOnly: t,
    required: r,
    "aria-hidden": !0,
    tabIndex: -1,
    style: se,
    onFocus() {
      var a;
      (a = x.current) == null || a.focus();
    }
  }, n.getInputValidationProps), J = u.useMemo(() => ({
    ...g,
    disabled: m ?? !1,
    required: r ?? !1,
    readOnly: t ?? !1
  }), [g, m, t, r]), U = u.useMemo(() => ({
    ...g,
    checkedValue: e,
    disabled: m,
    name: p,
    onValueChange: G,
    readOnly: t,
    registerControlRef: j,
    required: r,
    setCheckedValue: F,
    setTouched: b,
    touched: N
  }), [e, m, g, p, G, t, j, r, F, b, N]), W = {
    role: "radiogroup",
    "aria-required": r || void 0,
    "aria-disabled": m || void 0,
    "aria-readonly": t || void 0,
    "aria-labelledby": D,
    onFocus() {
      v(!0);
    },
    onBlur: K,
    onKeyDownCapture: q
  };
  return /* @__PURE__ */ o.jsxs(fe.Provider, {
    value: U,
    children: [/* @__PURE__ */ o.jsx(le, {
      render: i,
      className: c,
      state: J,
      props: [W, n.getValidationProps, _],
      refs: [s],
      customStyleHookMapping: pe,
      enableHomeAndEndKeys: !1,
      modifierKeys: Ve,
      stopEventPropagation: !0
    }), /* @__PURE__ */ o.jsx("input", {
      ...A
    })]
  });
});
process.env.NODE_ENV !== "production" && (M.displayName = "RadioGroup");
const be = X({
  base: ["Radio__group flex", "items-start", "text-gray-900"],
  variants: {
    orientation: {
      horizontal: "flex-row gap-x-2",
      vertical: "flex-col gap-y-2"
    },
    variant: {
      default: "",
      options: "flex-col gap-y-4 w-full",
      card: ""
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
}), Ce = (f) => {
  const {
    className: d,
    orientation: s = "horizontal",
    variant: i,
    ...c
  } = f, l = $(
    () => be({
      orientation: i === "options" ? "vertical" : s,
      variant: i,
      className: d
    }),
    [s, d, i]
  ), t = Q(
    (r = {}) => ({
      className: l,
      role: "radiogroup",
      "data-orientation": s,
      ...c,
      ...r
    }),
    [l, s, c]
  );
  return { variant: i, getRadioGroupProps: t };
}, Le = (f) => {
  const { variant: d, getRadioGroupProps: s } = Ce(f), { children: i, variantOptionLabel: c, label: l, ...t } = s();
  return /* @__PURE__ */ o.jsx(
    ee,
    {
      variant: d,
      variantOptionLabel: c,
      children: /* @__PURE__ */ o.jsxs(ge, { className: "flex flex-col items-start gap-1 w-full mb-2", children: [
        l && /* @__PURE__ */ o.jsx(ve, { className: Z(), render: /* @__PURE__ */ o.jsx("div", {}), children: l }),
        /* @__PURE__ */ o.jsx(M, { ...t, children: Y.Children.map(i, (r, R) => /* @__PURE__ */ o.jsx(oe, { index: R, children: r }, R)) }),
        /* @__PURE__ */ o.jsx(xe, {}),
        /* @__PURE__ */ o.jsx(he, {})
      ] })
    }
  );
};
export {
  Le as default
};
